// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tcqXfKvG54Fie3 {
  height: 100%;
}
.boGfhJD3xjJmow {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: var(--ds-space-050, 4px) var(--ds-space-150, 10px) 36px var(--ds-space-150, 10px);
  transition: padding 0.2s ease-in-out;
  background: var(--ds-surface, #ffffff);
}
.boGfhJD3xjJmow .wR_QW2gzXjQaae,
.boGfhJD3xjJmow .bmWZfnSNs9UIMS {
  position: relative;
  height: 100%;
}
.boGfhJD3xjJmow .bmWZfnSNs9UIMS {
  border-radius: var(--ds-border-radius-400, 16px);
}
.boGfhJD3xjJmow.q8w8ErS2bo8zqr {
  bottom: var(--ds-space-800, 64px);
}
.boGfhJD3xjJmow.syRgAz3NifuM8L {
  padding: var(--ds-space-0, 0);
}
.boGfhJD3xjJmow.syRgAz3NifuM8L .bmWZfnSNs9UIMS {
  border-radius: unset;
}
@media print {
  .boGfhJD3xjJmow {
    flex-direction: column;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manager": `tcqXfKvG54Fie3`,
	"splitscreen": `boGfhJD3xjJmow`,
	"content": `wR_QW2gzXjQaae`,
	"inboxContent": `bmWZfnSNs9UIMS`,
	"tabs": `q8w8ErS2bo8zqr`,
	"single": `syRgAz3NifuM8L`
};
export default ___CSS_LOADER_EXPORT___;
